import { Link, useLocation } from 'react-router-dom';
import store from '../assets/footer/store.svg';
import calendar from '../assets/footer/calendar.svg';
import contactFFLogo from '../assets/contact/contactFFLogo.svg';
import contactCuisineLocative from '../assets/contact/contactCuisineLocative.svg';
import icon_facebook from '../assets/header/icon_facebook.svg';
import icon_instagram from '../assets/header/icon_instagram.svg';
import incon_youtube from '../assets/header/incon_youtube.svg';
import icon_tiktok from '../assets/header/Tiktok.svg';
import '../styles/c_FooterNew.css';

function FooterNew() {
  const location = useLocation();
  const isCuisineLocative = location.pathname.toLowerCase().includes('cuisinelocative');
  const facebookUrl = isCuisineLocative
    ? 'https://www.facebook.com/CuisineLocativeSherbrooke'
    : 'https://www.facebook.com/FerventFerment/';
  return (
    <footer id="footerNewWrapper">
      <div className="footerNewContainer">
        {/* Section 1: Branding with Logos */}
        <div className="footerBranding">
          <div className="footerBrandingInfos">
            <div className="footerLogos">
              <img src={contactFFLogo} alt="Fervent Ferment Logo" className="footerFFLogo" />
              <img src={contactCuisineLocative} alt="Cuisine Locative" className="footerCLText" />
            </div>
            <div className="footerAddress">
              <p className="footerCompanyName">Fervent Ferment</p>
              <p className="footerStreet">1103 rue du conseil</p>
              <p className="footerCity">Sherbrooke, Québec</p>
              <p className="footerZip">J1G 1M4</p>
              <a href="tel:+18196685057">(819) 668-5057</a>
            </div>
          </div>
        </div>

        {/* Section 2: Boutique Info */}
        <div className="footerInfoSocial">
          <div className="footerBoutiqueInfo">
            <div className="footerInfoItem">
              <img src={calendar} alt="Calendar" className="footerInfoIcon" />
              <p className="footerInfoText">
                <a 
                  href={facebookUrl} 
                  target="_blank" 
                  rel="noreferrer"
                >
                  Consulter l&apos;horaire de la boutique
                </a>
              </p>
            </div>
            <div className="footerInfoItem">
              <img src={store} alt="Store" className="footerInfoIcon" />
              <p className="footerInfoText">
                <a 
                  href="https://ferventferment.square.site/atelier" 
                  target="_blank" 
                  rel="noreferrer"
                >
                  Voir les dates des prochains ateliers
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Section 3: Navigation Links & Social */}
        <div className="footerNavigation">
          <div className="footerNavColumns">
            <div className="footerNavLinks">
              <Link to="/">Accueil</Link>
              <a href="https://ferventferment.square.site/shop/boutiqueferment/14" target="_blank" rel="noreferrer">Boutique</a>
              <a href="https://ferventferment.square.site/atelier" target="_blank" rel="noreferrer">Ateliers</a>
              <a href="https://ferventferment.square.site/traiteur-personnalise" target="_blank" rel="noreferrer">Traiteur</a>
              <a href="https://ferventferment.square.site/product/le-club-de-fermentation-fervent-ferment/39?cp=true&sa=false&sbp=false&q=false&category_id=18" target="_blank" rel="noreferrer">Club</a>
            </div>
            <div className="footerNavLinks">
              <a href="https://ferventferment.square.site/granola-personnalise" target="_blank" rel="noopener noreferrer">Granola Personalisé</a>
              <a href="https://ferventferment.square.site/recettes" target="_blank" rel="noreferrer">Recettes</a>
              <Link to="/cuisinelocative">Cuisine Locative</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/a-propos">À propos</Link>
             
            </div>
          </div>

          <div className="footerSocialSection">
            <h3 className="footerSocialTitle">Suivez-nous</h3>
            <div className="footerSocialIcons">
              <a 
                href={facebookUrl} 
                target="_blank" 
                rel="noreferrer"
                aria-label="Facebook"
              >
                <img src={icon_facebook} alt="Facebook" />
              </a>
              <a 
                href="https://www.instagram.com/ferventferment/" 
                target="_blank" 
                rel="noreferrer"
                aria-label="Instagram"
              >
                <img src={icon_instagram} alt="Instagram" />
              </a>
              <a 
                href="https://www.youtube.com/@ferventferment" 
                target="_blank" 
                rel="noreferrer"
                aria-label="YouTube"
              >
                <img src={incon_youtube} alt="YouTube" />
              </a>
              <a 
                href="https://www.tiktok.com/@ferventferment" 
                target="_blank" 
                rel="noreferrer"
                aria-label="TikTok"
              >
                <img src={icon_tiktok} alt="TikTok" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footerBottom">
        <p className="footerCopyright">
          © {new Date().getFullYear()} Fervent Ferment. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}

export default FooterNew;
